var _mask, _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _g3, _path8, _path9, _g4, _path0, _path1, _g5, _path10, _path11, _g6, _path12, _path13, _path14, _g7, _path15, _g8, _path16, _path17, _g9, _path18, _path19, _g0, _path20, _path21, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallPwaPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 82,
    viewBox: "0 0 54 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_9700_24893",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0477295 8C0.0477295 3.58172 3.62945 0 8.04773 0H45.3492C49.7675 0 53.3492 3.58172 53.3492 8V81.6179H0.0477295V8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0477295 8C0.0477295 3.58172 3.62945 0 8.04773 0H45.3492C49.7675 0 53.3492 3.58172 53.3492 8V81.6179H0.0477295V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.95227 8C-1.95227 2.47715 2.52488 -2 8.04773 -2H45.3492C50.8721 -2 55.3492 2.47715 55.3492 8H51.3492C51.3492 4.68629 48.6629 2 45.3492 2H8.04773C4.73402 2 2.04773 4.68629 2.04773 8H-1.95227ZM53.3492 81.6179H0.0477295H53.3492ZM-1.95227 81.6179V8C-1.95227 2.47715 2.52488 -2 8.04773 -2V2C4.73402 2 2.04773 4.68629 2.04773 8V81.6179H-1.95227ZM45.3492 -2C50.8721 -2 55.3492 2.47715 55.3492 8V81.6179H51.3492V8C51.3492 4.68629 48.6629 2 45.3492 2V-2Z",
    fill: "#353535",
    mask: "url(#path-1-inside-1_9700_24893)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7503 32.0596C18.7503 32.0596 25.4826 31.5987 25.5284 38.8309C18.2898 38.785 18.7503 32.0596 18.7503 32.0596Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 31,
    width: 9,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3341 31.4766H26.0687V39.2864H18.3341V31.4766Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9215 39.2267L25.5256 39.2246C23.1909 39.209 21.375 38.5218 20.1279 37.1788C18.1755 35.0778 18.3516 32.1582 18.3599 32.0352L18.3829 31.6963L18.7235 31.6723C18.7235 31.6723 18.8194 31.665 18.9882 31.665C20.1383 31.665 25.8757 32.0112 25.9194 38.8305L25.9215 39.2267Z",
    fill: "url(#paint0_linear_9700_24893)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 24,
    width: 7,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9344 24.3701H29.5353V35.2131H23.9344V24.3701Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7676 35.0759L26.4894 34.7944C24.8485 33.1344 24.0515 31.3649 24.1203 29.535C24.2276 26.6697 26.4175 24.7302 26.5113 24.65L26.7676 24.4258L27.0249 24.65C27.1187 24.7302 29.3086 26.6697 29.4159 29.535C29.4847 31.3649 28.6877 33.1344 27.0468 34.7944L26.7676 35.0759Z",
    fill: "url(#paint1_linear_9700_24893)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9769 32.0596C34.9769 32.0596 28.2456 31.5987 28.1987 38.8309C35.4384 38.785 34.9769 32.0596 34.9769 32.0596Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 31,
    width: 9,
    height: 9
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6676 31.4766H35.4021V39.2864H27.6676V31.4766Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8049 39.2277L27.8081 38.8314C27.8518 32.0122 33.5892 31.666 34.7383 31.666C34.9081 31.666 35.004 31.6733 35.004 31.6733L35.3436 31.6973L35.3676 32.0362C35.3759 32.1592 35.552 35.0777 33.5996 37.1798C32.3536 38.5228 30.5366 39.2099 28.2008 39.2256L27.8049 39.2277Z",
    fill: "url(#paint2_linear_9700_24893)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 35,
    width: 19,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7987 35.916H35.9349V56.8054H17.7987V35.916Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9700_24893)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 35,
    width: 19,
    height: 22
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1207 56.8066V35.9339C30.0592 35.9297 29.9988 35.9297 29.9373 35.9297H23.803V56.8066H30.1207ZM22.2309 56.8066H23.803V35.9339H23.7686C21.2265 35.9339 18.9949 38.0099 18.8116 40.5447L17.9521 52.201C17.7635 54.7306 19.6898 56.8066 22.2309 56.8066ZM31.474 56.8066C34.0161 56.8066 35.9414 54.7306 35.7538 52.1958L34.8933 40.5405C34.7099 38.0672 32.5794 36.0308 30.1165 35.9339V56.8066H31.474Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7668 56.8064H17.9515V35.917H35.7668V56.8064Z",
    fill: "#FFDE59"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 35,
    width: 9,
    height: 9
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5372 35.3887H25.6573V43.5155H17.5372V35.3887Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9700_24893)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 35,
    width: 9,
    height: 9
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5972 35.3906C19.3552 35.3906 17.5372 37.2091 17.5372 39.454C17.5372 41.6979 19.3552 43.5174 21.5972 43.5174C23.8393 43.5174 25.6573 41.6979 25.6573 39.454C25.6573 37.2091 23.8393 35.3906 21.5972 35.3906Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5372 35.3906H25.6573V43.5174H17.5372V35.3906Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 36,
    width: 6,
    height: 6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0687 36.9131H24.132V41.9816H19.0687V36.9131Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_9700_24893)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 36,
    width: 6,
    height: 6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6011 36.9131C20.203 36.9131 19.0695 38.0475 19.0695 39.4479C19.0695 40.8472 20.203 41.9816 21.6011 41.9816C22.9992 41.9816 24.1328 40.8472 24.1328 39.4479C24.1328 38.0475 22.9992 36.9131 21.6011 36.9131Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0695 36.9131H24.1328V41.9816H19.0695V36.9131Z",
    fill: "#3D1F1E"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6703 39.8813C20.6703 39.2714 21.1246 38.8318 21.7207 38.8318C21.1523 38.8318 20.6708 38.3634 20.6708 37.7817C20.6708 38.3579 20.2214 38.8318 19.6199 38.8318C20.2214 38.8318 20.6703 39.2936 20.6703 39.8813Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6703 37.7812L20.6708 37.7817M20.6708 37.7817C20.6708 38.3634 21.1523 38.8318 21.7207 38.8318C21.1246 38.8318 20.6703 39.2714 20.6703 39.8813C20.6703 39.2936 20.2214 38.8318 19.6199 38.8318C20.2214 38.8318 20.6708 38.3579 20.6708 37.7817Z",
    stroke: "white",
    strokeWidth: 0.537721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 48,
    width: 6,
    height: 3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4646 48.2002H29.3105V50.3768H24.4646V48.2002Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8876 50.9468C26.7285 50.9468 26.5712 50.9381 26.4157 50.9204C26.2592 50.903 26.1081 50.8769 25.9613 50.8425C25.8145 50.8077 25.6748 50.7656 25.543 50.7155C25.4103 50.6654 25.2881 50.6084 25.1756 50.5447C25.0631 50.4807 24.9629 50.4115 24.8751 50.3364C24.7863 50.2616 24.7116 50.1823 24.651 50.0989C24.5903 50.0157 24.5446 49.9298 24.513 49.8415C24.4822 49.7528 24.4673 49.6638 24.4673 49.5733C24.4673 49.4832 24.4822 49.3939 24.513 49.3055C24.5446 49.2172 24.5903 49.1313 24.651 49.0478C24.7116 48.9647 24.7863 48.8854 24.8751 48.8106C24.9629 48.7355 25.0631 48.6663 25.1756 48.6023C25.2881 48.5386 25.4103 48.4816 25.543 48.4315C25.6748 48.3814 25.8145 48.3393 25.9613 48.3045C26.1081 48.2701 26.2592 48.244 26.4157 48.2266C26.5712 48.2089 26.7285 48.2002 26.8876 48.2002C27.0467 48.2002 27.204 48.2089 27.3595 48.2266C27.516 48.244 27.6671 48.2701 27.8139 48.3045C27.9607 48.3393 28.1004 48.3814 28.2322 48.4315C28.3649 48.4816 28.4871 48.5386 28.5996 48.6023C28.7121 48.6663 28.8123 48.7355 28.9001 48.8106C28.9889 48.8854 29.0636 48.9647 29.1242 49.0478C29.1849 49.1313 29.2306 49.2172 29.2622 49.3055C29.293 49.3939 29.3079 49.4832 29.3079 49.5733C29.3079 49.6638 29.293 49.7528 29.2622 49.8415C29.2306 49.9298 29.1849 50.0157 29.1242 50.0989C29.0636 50.1823 28.9889 50.2616 28.9001 50.3364C28.8123 50.4115 28.7121 50.4807 28.5996 50.5447C28.4871 50.6084 28.3649 50.6654 28.2322 50.7155C28.1004 50.7656 27.9607 50.8077 27.8139 50.8425C27.6671 50.8769 27.516 50.903 27.3595 50.9204C27.204 50.9381 27.0467 50.9468 26.8876 50.9468Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 50,
    width: 5,
    height: 1
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9579 50.1318H28.8176V50.6205H24.9579V50.1318Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8176 50.3761C28.8176 50.3921 28.8047 50.4079 28.7804 50.4237C28.7553 50.4394 28.7189 50.4547 28.6703 50.4695C28.6217 50.4843 28.5627 50.4983 28.4922 50.5117C28.4218 50.525 28.3417 50.5374 28.2518 50.5486C28.1628 50.5601 28.0648 50.5702 27.9596 50.579C27.8543 50.588 27.7434 50.5954 27.626 50.6015C27.5087 50.6077 27.388 50.6124 27.2642 50.6155C27.1395 50.6187 27.0141 50.6202 26.8878 50.6202C26.7607 50.6202 26.6352 50.6187 26.5113 50.6155C26.3867 50.6124 26.2661 50.6077 26.1487 50.6015C26.0321 50.5954 25.9204 50.588 25.8152 50.579C25.7099 50.5702 25.612 50.5601 25.5229 50.5486C25.4331 50.5374 25.3529 50.525 25.2825 50.5117C25.2121 50.4983 25.153 50.4843 25.1044 50.4695C25.0558 50.4547 25.0194 50.4394 24.9943 50.4237C24.97 50.4079 24.9579 50.3921 24.9579 50.3761C24.9579 50.36 24.97 50.3442 24.9943 50.3283C25.0194 50.3126 25.0558 50.2974 25.1044 50.2826C25.153 50.2677 25.2121 50.2538 25.2825 50.2404C25.3529 50.2271 25.4331 50.2147 25.5229 50.2034C25.612 50.192 25.7099 50.1819 25.8152 50.173C25.9204 50.1641 26.0321 50.1566 26.1487 50.1505C26.2661 50.1444 26.3867 50.1397 26.5113 50.1365C26.6352 50.1334 26.7607 50.1318 26.8878 50.1318C27.0141 50.1318 27.1395 50.1334 27.2642 50.1365C27.388 50.1397 27.5087 50.1444 27.626 50.1505C27.7434 50.1566 27.8543 50.1641 27.9596 50.173C28.0648 50.1819 28.1628 50.192 28.2518 50.2034C28.3417 50.2147 28.4218 50.2271 28.4922 50.2404C28.5627 50.2538 28.6217 50.2677 28.6703 50.2826C28.7189 50.2974 28.7553 50.3126 28.7804 50.3283C28.8047 50.3442 28.8176 50.36 28.8176 50.3761Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 35,
    width: 9,
    height: 9
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0529 35.3887H36.1729V43.5155H28.0529V35.3887Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_9700_24893)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 35,
    width: 9,
    height: 9
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1153 35.3906C29.8722 35.3906 28.0553 37.2091 28.0553 39.454C28.0553 41.6979 29.8722 43.5174 32.1153 43.5174C34.3573 43.5174 36.1753 41.6979 36.1753 39.454C36.1753 37.2091 34.3573 35.3906 32.1153 35.3906Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0553 35.3906H36.1753V43.5174H28.0553V35.3906Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 36,
    width: 6,
    height: 6
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5776 36.9131H34.642V41.9816H29.5776V36.9131Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_9700_24893)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_9700_24893",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 36,
    width: 6,
    height: 6
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1096 36.9131C30.7104 36.9131 29.5769 38.0475 29.5769 39.4479C29.5769 40.8472 30.7104 41.9816 32.1096 41.9816C33.5077 41.9816 34.6412 40.8472 34.6412 39.4479C34.6412 38.0475 33.5077 36.9131 32.1096 36.9131Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_9700_24893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5769 36.9131H34.6412V41.9816H29.5769V36.9131Z",
    fill: "#3D1F1E"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3405 39.81C31.3405 39.2001 31.7948 38.7605 32.3909 38.7605C31.8225 38.7605 31.341 38.2921 31.341 37.7104C31.341 38.2866 30.8916 38.7605 30.29 38.7605C30.8916 38.7605 31.3405 39.2223 31.3405 39.81Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3405 37.71L31.341 37.7104M31.341 37.7104C31.341 38.2921 31.8225 38.7605 32.3909 38.7605C31.7948 38.7605 31.3405 39.2001 31.3405 39.81C31.3405 39.2223 30.8916 38.7605 30.29 38.7605C30.8916 38.7605 31.341 38.2866 31.341 37.7104Z",
    stroke: "white",
    strokeWidth: 0.537721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.0356,
    y: 3.33105,
    width: 13.3254,
    height: 4.16418,
    rx: 2.08209,
    fill: "#353535"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9700_24893",
    x1: 22.137,
    y1: 31.665,
    x2: 22.137,
    y2: 39.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9700_24893",
    x1: 26.7681,
    y1: 24.4258,
    x2: 26.7681,
    y2: 35.0759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9700_24893",
    x1: 31.59,
    y1: 31.666,
    x2: 31.59,
    y2: 39.2277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallPwaPhone);
export default __webpack_public_path__ + "static/media/installPwaPhone.caa44e96a5462796d553435a2f53b1b4.svg";
export { ForwardRef as ReactComponent };